module.exports = __webpack_public_path__ + "static/media/GymGuy_idle.9646021e.png";